module.exports = __webpack_public_path__ + "img/20_125.1877705b.png";